'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var capitalize = {};

exports.__exports = capitalize;
